import './popinCleanBasket.css';

/**
 * Clean basket popin template
 * @param {object} datas
 * @param {string} datas.title
 * @param {string} datas.text
 * @param {string} datas.href
 * @param {string} datas.btn_cancel - cancel wording text
 * @param {string} datas.btn_confirm - confirm wording text
 * @param {string} datas.origin - parent event data attribute
 * @param {string} datas.facetteToOpen - data attribute
 * @return {string} - Formatted HTML
 */
const popinCleanBasketTpl = function (datas) {
  let htmlCartouche = `
  <div class="popinCleanBasket" data-event="${datas.origin}">
    <i class="icon icon-close js-close"></i>
    <strong>${datas.title}</strong>
    <p>${datas.text}</p>
    <div class="button-container">`;
  if (datas.btn_cancel !== '') {
    htmlCartouche += `
    <button class="button button--whiteBlack js-cancel">${datas.btn_cancel}</button>`;
  }
  htmlCartouche += `
      <a ${datas.href ? 'href="' + datas.href + '"' : ''} class="button button--greenWhite${!datas.href ? ' js-confirm' : ' js-confirmExit'}" data-facetteToOpen=${datas.facetteToOpen}>${datas.btn_confirm}</a>
    </div>
  </div>`;

  return htmlCartouche;
};

export { popinCleanBasketTpl };
